<div
    class="btn-group d-flex d-sm-inline-block"
    [class.w-100]="useInputField"
    dropdown
    [insideClick]="insideClick"
    [isDisabled]="useInputField && !hasOptions"
>
    @if (useInputField) {
        <div
            class="input-toggle-wrapper position-relative w-100 input-group"
            [class.dropdown-toggle]="hasOptions"
            dropdownToggle
            aria-controls="dropdown-autoclose1"
        >
            <input
                type="text"
                class="form-control text-start pe-2"
                [id]="inputId"
                [value]="value"
                (input)="onInput($event)"
                (blur)="onTouched()"
                [disabled]="disabled"
                [placeholder]="inputPlaceholder"
            />
            @if (showScanner) {
                <span class="input-group-text pb-0" id="addon-wrapping" (click)="openScanner($event)">
                    <fa-icon [icon]="faBarcode" class="fs-4" size="1x"></fa-icon
                ></span>
            }
        </div>
    } @else {
        <button
            id="button-autoclose1"
            dropdownToggle
            type="button"
            class="btn btn-secondary dropdown-toggle overflow-button d-flex align-items-center justify-content-between text-start"
            aria-controls="dropdown-autoclose1"
            [disabled]="disabled"
            [ngClass]="{ 'disable-dropdown': disabled }"
        >
            {{ dropDownText || defaultDropDownButtonText }}
        </button>
    }
    <ul id="dropdown-autoclose1" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-autoclose1">
        <ng-content></ng-content>
    </ul>
</div>
